import React, { createContext, useState, useContext } from "react";
import { SimpleModal } from "../Components/SimpleModal";

// Create UserContext
const ModalContext = createContext();

// Create a provider component
export const ModalProvider = ({ children }) => {
    const [modalMessage, setModalMessage] = useState(null); // Initial user state is null
    const [displayModal, setDisplayModal] = useState(false); // Initial user state is null
    const onModalClose = () => {};

    const showModal = (message) => {setModalMessage(message); setDisplayModal(true);};
    const hideModal = () => {setModalMessage(null); setDisplayModal(false);};

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}

            <SimpleModal message={modalMessage} show={displayModal} onModalClose={onModalClose}></SimpleModal>

        </ModalContext.Provider>
    );
};

// Hook to use the UserContext
export const useModal = () => useContext(ModalContext);
